var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "input-code"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.phone,
      expression: "phone"
    }],
    staticClass: "phone-input",
    class: {
      mb: _vm.mb,
      changeb: _vm.phone
    },
    attrs: {
      "id": "phoneInput",
      "autocomplete": "off",
      "name": "phoneInput",
      "type": "tel",
      "placeholder": _vm.$t(_vm.$loginLangPrefix('userSign.phPhoneTips'))
    },
    domProps: {
      "value": _vm.phone
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.next();
      },
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.phone = $event.target.value;
      }, _vm.phoneInput]
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.phone,
      expression: "phone"
    }],
    staticClass: "delete",
    class: {
      mb: _vm.mb
    },
    on: {
      "click": function click($event) {
        return _vm.deleteInput();
      }
    }
  })]);
};
var staticRenderFns = [];
export { render, staticRenderFns };